export default "__VITE_ASSET__BL2T0jDK__"